// Roles every environment has: the db seed creates them, and bootstrapping the first admin
// looks them up by name.
export const ROLE_NAME = {
    ADMIN: 'Admin',
};
